export enum UniformTypes {
  Person = "PERSON",
  Entity = "ENTITY",
  EntityGroup = "ENTITYGROUP",
}
